import {
    IonContent,
    IonPage,
    IonSkeletonText,
    IonIcon,
    IonLabel,
    IonCard,
    IonItem,
    IonList,
    IonListHeader,
    IonThumbnail,
    IonImg,
    useIonAlert,
    IonText,
    IonHeader,
    IonToolbar,
    IonButton,
    useIonModal,
    IonRefresher,
    IonBadge,
    IonRefresherContent,
    IonGrid,
    IonRow,
    IonCol
} from '@ionic/react';
import { RefresherEventDetail } from '@ionic/core';
import React, { useState } from 'react';
import { storefront, arrowBackOutline, logIn, logOut, chatboxEllipses, chevronDownCircleOutline, calendar } from 'ionicons/icons';
import { RestApi } from '../services/Api';
import { getNameDate, useConstructor } from '../services/Library';
import Detail from '../components/visit/Detail';
import { useSelector, useDispatch } from "react-redux";
import { VisitAction } from "../data/state/VisitReducer";
import { CustomerAction } from "../data/state/CustomerReducer";
import { Preferences } from '@capacitor/preferences'
import Calendar from '../components/visit/Calendar';
import { loadList } from '../models/Data';
import { useTranslation } from 'react-i18next';
import './Visit.scss';

const Visit: React.FC = () => {
  const { t } = useTranslation(["general"]);
  const [alert] = useIonAlert();
  const dispatch = useDispatch();
  const [getDetailVisit, setGetDetailVisit] = useState<any>([]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const listVisit = useSelector((state:any) => state.visit.value) || [];
  const [visitSummary, setVisitSummary] = useState<any>({});

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
      dispatch(CustomerAction.setCustomer([]))
      getVisitList()
      getVisitSummary()
      setVisitSummary({})
      setGetDetailVisit([])
      event.detail.complete();
  }

  const handleDismissCalendar = () => {
    dispatch(CustomerAction.setCustomer([]));
    dismissCalendar();
  };

  const [presentCalendar, dismissCalendar] = useIonModal(Calendar, {
    onDismissCalendar: handleDismissCalendar,
  });

  const handleDismissDetail = () => {
      dispatch(CustomerAction.setCustomer([]))
      dismissDetail()
  }

  const [presentDetail, dismissDetail] = useIonModal(Detail, {
    detailVisit: getDetailVisit,
    onDismissDetail: handleDismissDetail,
    type: "visit",
  });

  const massageAlert = async (status:string,body:string) => {
    alert({
      header: t(status),
      message: body,
      cssClass: `header-alert-${status}`,
      buttons: [
        { text: t('yes'), cssClass: "alert-button-confirm", role: "confirm" },
      ],
    });
  }

  const getVisitList = async () => {
      setLoaded(false)
      Preferences.remove({key: "visitOn"});
      await RestApi(`visit`,'get',{},'application/json')
      .then((res:any) => {
          if (res.data.status) {
              dispatch(VisitAction.setVisit(res.data.data))
              for (const visit of res.data.data) {
                visitCheck(visit)
              }
          }else{
              dispatch(VisitAction.setVisit([]))
              massageAlert('error',res.data.message)
          }
          setLoaded(true)
      })
      .catch((err:any) => {
          massageAlert('error',err.message)
          setLoaded(true)
      });
  }

  const getVisitSummary = async () => { 
      await RestApi(`dashboard/visit-summary`,'get',{},'application/json')
      .then((res:any) => {
          if (res.data.status) {
              setVisitSummary(res.data.data || {})
          }else{
              setVisitSummary({})
              massageAlert('error',res.data.message)
          }
      })
      .catch((err:any) => {
          massageAlert('error',err.message)
      });
  }

  const getVisitDetail = async (value:any) => {
      dispatch(CustomerAction.setCustomer(value))
      setGetDetailVisit(value)
      presentDetail({
        cssClass: "modal-fullscreen",
      });
  }
  
  const checkStatus = (status:any) =>{
      switch(status) {
          case 0:
              return {
                  color : 'danger',
                  icon : logIn
              };
          case 1:
              return {
                  color : 'success',
                  icon : logOut
              };
          default:
              return {
                  color : 'tertiary',
                  icon : storefront
              };
      }
  }
  const visitCheck = (value: any) => {
    if (value.visit_hist_type === 0 && getDetailVisit.customer_id !== value.customer_id ) {
        Preferences.set({key: "visitOn", value: JSON.stringify(value) });
        alert({
            header: `Customer ${value.customer_id} Belum Di Proses !`,
            message: `${value.visitdet_note === ''?'Isi Catatan':'Check Out'} Sekarang Atau nanti?`,
            cssClass: 'header-alert',
            buttons: [
                {
                    text: 'Nanti',
                    cssClass: 'alert-button-cancel',
                    role: 'cancel',
                },
                {
                    text: 'Sekarang',
                    cssClass: 'alert-button-confirm',
                    role: 'confirm',
                    handler:  () => {
                        dispatch(CustomerAction.setCustomer(value))
                        setGetDetailVisit(value)
                        presentDetail({
                          cssClass: "modal-fullscreen",
                        });
                },
            }]
        })
    }else{
      return null;
    }
  }

  useConstructor(() => {
    dispatch(CustomerAction.setCustomer([]))
    getVisitList()
    setGetDetailVisit([])
    getVisitSummary()
  });

  // Helper for currency format (IDR)
  function formatRupiah(num: number | string): string {
    if (!num && num !== 0) return "-";
    return "Rp " + (Number(num) || 0).toLocaleString("id-ID");
  }

  return (
    <IonPage>
      <IonHeader className="toolbar-visit">
        {loaded ? (
          <IonToolbar>
            <IonButton
              color="light"
              slot="start"
              fill="clear"
              routerLink="/home"
              routerDirection="back"
              className=""
              size="small"
            >
              <IonIcon color="light" src={arrowBackOutline} />
            </IonButton>
            <IonLabel color="light" className="ion-text-center ion-no-padding">
              <h1>
                <strong>{listVisit[0]?.visit_id}</strong>
              </h1>
              <h4>{getNameDate(listVisit[0]?.visit_date)}</h4>
            </IonLabel>
            <IonButton
              color="light"
              onClick={() => {
                presentCalendar({
                  cssClass: "modal-fullscreen",
                });
              }}
              slot="end"
              fill="clear"
            >
              <IonIcon color="light" src={calendar} />
            </IonButton>
          </IonToolbar>
        ) : (
          <IonToolbar>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%" }}
            ></IonSkeletonText>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent className="content-visit">
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={t("loading") ?? ""}
            refreshingSpinner="circles"
            refreshingText={t("loading") ?? ""}
          ></IonRefresherContent>
        </IonRefresher>
        {!loaded && (
          <IonList>
            <IonListHeader>
              <IonSkeletonText
                animated={true}
                style={{ width: "80px" }}
              ></IonSkeletonText>
            </IonListHeader>
            {loadList.map((value: any, key: any) => (
              <IonItem key={key}>
                <IonThumbnail slot="start">
                  <IonSkeletonText animated={true}></IonSkeletonText>
                </IonThumbnail>
                <IonLabel>
                  <h3>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "80%" }}
                    ></IonSkeletonText>
                  </h3>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "60%" }}
                    ></IonSkeletonText>
                  </p>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "30%" }}
                    ></IonSkeletonText>
                  </p>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}
        {listVisit.length && loaded ? (
          <>
            {(visitSummary && Object.keys(visitSummary).length > 0) && (
              <IonCard className="visit-summary-card p-0 m-0" style={{ borderRadius: 18, boxShadow: "0 2px 14px 0 rgba(52, 96, 179, 0.08)", margin: 5, padding: 5 }}>
                <div className="p-0 m-0" style={{ padding: 0 }}>
                  <IonGrid className="p-0 m-0" style={{ "--ion-grid-padding": "0", padding: 0, margin: 0 }}>
                    <IonRow className="p-0 m-0" style={{ fontSize: 13, color: "#31405e", textAlign: "center", margin: 0, padding: 0 }}>
                      <IonCol size="4" className="p-0 m-0">
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#118c4f", marginBottom: 3 }}>
                          {visitSummary.total_visit ?? '-'}
                        </div>
                        <div style={{ fontSize: 12, color: "#818ba0" }}>Plan</div>
                      </IonCol>
                      <IonCol size="4" className="p-0 m-0">
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#0075bc", marginBottom: 3 }}>
                          {visitSummary.total_visited ?? '-'}
                        </div>
                        <div style={{ fontSize: 12, color: "#818ba0" }}>Visit</div>
                      </IonCol>
                      <IonCol size="4" className="p-0 m-0">
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#c0392b", marginBottom: 3 }}>
                          {visitSummary.total_customer ?? '-'}
                        </div>
                        <div style={{ fontSize: 12, color: "#818ba0" }}>Cust. Trans.</div>
                      </IonCol>
                    </IonRow>
                      <hr />
                    <IonRow className="p-0 m-0" style={{ fontSize: 13, color: "#31405e", textAlign: "center", margin: 0, padding: 0 }}>
                      <IonCol size="4" className="p-0 m-0" style={{ textAlign: "center", margin: 0, padding: 0 }}>
                        <div style={{ fontSize: 12, color: "#818ba0", marginBottom: 2 }}>Amount (SI)</div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#2471a3" }}>
                          {formatRupiah(visitSummary.total_amount)}
                        </div>
                      </IonCol>
                      <IonCol size="4" className="p-0 m-0" style={{ textAlign: "center", margin: 0, padding: 0 }}>
                        <div style={{ fontSize: 12, color: "#818ba0", marginBottom: 2 }}>Rasio. Plan</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#4a69bd" }}>
                          {visitSummary.rasio_visited ?? '-'}%
                        </div>
                      </IonCol>
                      <IonCol size="4" className="p-0 m-0" style={{ textAlign: "center", margin: 0, padding: 0 }}>
                        <div style={{ fontSize: 12, color: "#818ba0", marginBottom: 2 }}>Rasio. Trans.</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#38ada9" }}>
                          {visitSummary.rasio_sales ?? '-'}%
                        </div>
                      </IonCol>
                    </IonRow>
                    
                  </IonGrid>
                </div>
              </IonCard>
            )}
            <IonText className="ion-text-center ion-no-padding">
              <h4>
                <strong>
                  Total Kunjungan {" "}
                  {listVisit.filter((e: any) => e.visit_hist_type === 1).length}
                  /{listVisit.length}
                </strong>
              </h4>
            </IonText>
            {/* End Data Visit Summary */}
            <IonList className="main-card">
              {listVisit.map((value: any, key: any) => (
                <IonCard
                  key={key}
                  className="visit-card"
                  style={{
                    borderRadius: 18,
                    boxShadow: "0 2px 12px 0 rgba(44,62,80,.09)",
                    border: "1px solid #ececec",
                    background: "#fff",
                    marginBottom: 16,
                    cursor: "pointer",
                    transition: "box-shadow 0.2s",
                    padding: 0,
                  }}
                  onClick={() => getVisitDetail(value)}
                >
                  <div
                    style={{
                      padding: "16px 16px 0 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                    }}
                  >
                    <div
                      style={{
                        background: "#f0f6ff",
                        borderRadius: "50%",
                        width: 46,
                        height: 46,
                        minWidth: 46,
                        minHeight: 46,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #e3eafd",
                        fontWeight: 600,
                        fontSize: 22,
                        color: "#861205",
                        boxShadow: "0 2px 8px #f2f4ff",
                        letterSpacing: "2px",
                      }}
                    >
                      {key + 1}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "1.1em",
                          color: "#173555",
                          lineHeight: 1.22,
                          marginBottom: 2,
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        title={key + 1}
                      >
                        {value.customer_name}
                        <IonBadge
                          color="primary"
                          style={{
                            marginLeft: 8,
                            background: "#e5f0fc",
                            color: "#861205",
                            fontWeight: 600,
                            fontSize: 13,
                            borderRadius: 7,
                            minWidth: 34,
                            verticalAlign: "middle",
                          }}
                        >
                          {value.customer_id}
                        </IonBadge>
                      </div>
                      <div
                        style={{
                          color: "#6d7682",
                          fontSize: "0.96em",
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          margin: "0 0 0 0",
                        }}
                      >
                        <p
                          style={{
                            background: "#f7faff",
                            color: "#3867d6",
                            fontWeight: 500,
                            fontSize: "0.93em",
                            borderRadius: 5,
                            padding: "2px 8px",
                            letterSpacing: ".5px",
                            whiteSpace: "wrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                          }}
                          title={value.customer_address_name}
                        >
                          {value.customer_address_name}
                        </p>
                        <span
                          style={{
                            fontSize: "0.93em",
                            color: "#586069",
                            background: "#f9f9fc",
                            borderRadius: 5,
                            padding: "2px 8px",
                            whiteSpace: "wrap",
                          }}
                          title={value.customer_address}
                        >
                          {value.customer_address}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{ marginLeft: "auto", display: "flex", gap: 8 }}
                    >
                      <IonIcon
                        size="medium"
                        color={checkStatus(value.visit_hist_type).color}
                        src={checkStatus(value.visit_hist_type).icon}
                        style={{
                          fontSize: 23,
                          marginRight: value.visitdet_note ? 2 : 0,
                        }}
                      />
                      {value.visitdet_note && (
                        <IonIcon
                          size="small"
                          color="danger"
                          src={chatboxEllipses}
                          style={{ fontSize: 21 }}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "0 16px 10px 76px",
                      marginTop: 2,
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      border: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "#636e72",
                        fontSize: "0.99em",
                        lineHeight: 1.5,
                        wordBreak: "break-word",
                        whiteSpace: "pre-line",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxHeight: "3.2em",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        fontWeight: 500,
                        letterSpacing: ".1px",
                      }}
                      title={value.customer_address}
                    >
                      {value.customer_phone ? (
                        <>
                          <IonIcon
                            src="assets/icon/phone-outline.svg"
                            style={{
                              marginRight: 8,
                              color: "#2471a3",
                              fontSize: 17,
                              verticalAlign: "middle",
                            }}
                          />
                          <span style={{ color: "#2471a3" }}>
                            {value.customer_contact_name} - {value.customer_phone}
                          </span>
                        </>
                      ) : (
                        <span style={{ color: "#c1c9d1", fontStyle: "italic" }}>
                          No Phone
                        </span>
                      )}
                    </div>
                  </div>
                </IonCard>
              ))}
            </IonList>
          </>
        ) : (
          <IonImg className="img-empty" src={"assets/img/search-empty.png"} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default Visit;
